<template>
  <div />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'onetrust',
  props: {
    settings: {
      type: Object,
      default: {
        marketing: '',
      }
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing',
    ])
  },
  created() {
    const self = this

    this.init(this.settings)

    window.renewCookieBot = this.renewCookieBot

    window.OptanonWrapper = () => {
      self.initialize(window.OnetrustActiveGroups)

      window.OneTrust.OnConsentChanged((onetrust) => {
        self.changeOneTrust(onetrust.detail)
        setTimeout(() => { window.location.reload(true) }, 1000)
      })
    }
  },
  methods: {
    ...mapActions('onetrust', [
      'check',
      'init'
    ]),
    renewCookieBot(event) {
      if (event) event.preventDefault()
      window.OneTrust.ToggleInfoDisplay()
    },
    initialize(groups) {
      const dataItems = groups.split(',')
        .filter(item => !!item)

      this.changeOneTrust(dataItems)
    },
    changeOneTrust(data) {
      window.console.log(data)
      const domainData = window.OneTrust.GetDomainData()
      const hasInteraction = domainData.ConsentIntegrationData.consentPayload.customPayload.Interaction

      this.check({
        consent: data,
        consented: hasInteraction > 0
      })
    }
  }
}
</script>
